import { Link } from "react-router-dom";
import { useTheme } from "../../context/ThemeContext";

export default function QuickActionCard({
  title,
  description,
  to,
}) {

  const { isDark } = useTheme();

  return (
    <Link
      to={to}
      className={`
        block
        rounded-3xl
        border
        p-6
        transition-all
        duration-300
        hover:-translate-y-1
        ${
          isDark
            ? `
              bg-white/5
              border-white/10
              hover:border-blue-800/50
              hover:bg-white/10
            `
            : `
              bg-white
              border-gray-200
              hover:border-blue-800
            `
        }
      `}
    >
      <h3 className="text-lg font-semibold">
        {title}
      </h3>

      <p
        className={`
          mt-2
          text-sm
          ${
            isDark
              ? "text-gray-400"
              : "text-gray-500"
          }
        `}
      >
        {description}
      </p>
    </Link>
  );
}